<div class="content">
  <div class="row">
    <div class="col-10">
      <h3>Offices</h3>
    </div>

    <div class="col-2 page-actions">
      <button type="submit" class="btn btn-primary" (click)="onAddOfficeClick($event)">Add Office</button>
    </div>
  </div>

  <div class="container-fluid p-1 my-2 px-3 border rounded bg-light">
    <form novalidate>
      <div class="row small-gutters my-1">
        <div class="col-3">
          <label for="name">Name:</label>
          <input
            id="name"
            class="form-control"
            name="name"
            placeholder="Filter By Name"
            [(ngModel)]="filters.name"
            (input)="onTextFilterChange()" />
        </div>
        <div class="col-3">
          <label for="phone">Phone:</label>
          <input
            id="phone"
            class="form-control"
            name="phone"
            placeholder="Filter By Phone"
            [(ngModel)]="filters.phone"
            (input)="onTextFilterChange()" />
        </div>
        <div class="col-3">
          <label for="fax">Fax:</label>
          <input
            id="fax"
            class="form-control"
            name="fax"
            placeholder="Filter By Fax"
            [(ngModel)]="filters.fax"
            (input)="onTextFilterChange()" />
        </div>
        <div class="col-3">
          <label for="city">City:</label>
          <input
            id="city"
            class="form-control"
            name="city"
            placeholder="Filter By City"
            [(ngModel)]="filters.city"
            (input)="onTextFilterChange()" />
        </div>
      </div>
      <div class="row small-gutters my-1">
        <div class="col-3">
          <label for="state">State:</label>
          <ng-select
            bindValue="value"
            bindLabel="display"
            [(ngModel)]="filters.state"
            [items]="stateOptions"
            placeholder="Filter By State"
            name="state"
            (change)="onFilterChange()" />
        </div>
        <div class="col-3">
          <label for="status">Status:</label>
          <ng-select
            bindValue="value"
            bindLabel="display"
            [(ngModel)]="filters.status"
            [items]="officeStatusOptions"
            placeholder="Filter By Status"
            name="status"
            [multiple]="true"
            (remove)="onFilterChange()"
            (change)="onFilterChange()" />
        </div>
        <div class="col-3">
          <br />
          <div class="mt-2">
            <div class="d-flex flex-row align-items-center">
              <div class="col-auto px-1">
                <label for="hieConsultNotesCollected">HIE:</label>
              </div>

              <div class="col-auto px-1">
                <mat-slide-toggle name="hieConsultNotesCollected"
                  [color]="'primary'"
                  [(ngModel)]="filters.hieConsultNotesCollected"
                  [disableRipple]="true"
                  (change)="onFilterChange()" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  @if (!loading) {
    <div class="mt-2">
      <app-pagination-header
        [paging]="paging"
        [label]="'offices'"
        (pageSizeChange)="onPageSizeChange($event)"
        [includeResetFiltersButton]="true"
        (resetFiltersClick)="onResetFiltersClick()" />
      @if (offices.length > 0) {
        <div class="mt-2">
          <table class="table table-bordered table-hover">
            <thead class="table-dark">
              <tr>
                <th>ID</th>
                <th>NAME</th>
                <th>AKA</th>
                <th>PHONE</th>
                <th>FAX</th>
                <th>OFFICE STATUS</th>
                <th>ADDRESS</th>
                <th>CITY</th>
                <th>STATE</th>
                <th>PROVIDER COUNT</th>
                <th>LAST UPDATED</th>
              </tr>
            </thead>
            <tbody>
              @for (office of offices; track office) {
                <tr>
                  <td>
                    <a
                      routerLink="/capture-admin/offices/{{office.id}}"
                      routerLinkActive="active"
                      [routerLinkActiveOptions]="{ exact: true }"
                      >
                      {{ office.id }}
                    </a>
                  </td>
                  <td>
                    {{ office.name | blankValueDash }}
                  </td>
                  <td>
                    {{ office.aka | blankValueDash }}
                  </td>
                  <td>
                    <span class="text-nowrap">
                      <app-phone-number [number]="office.phone" [allowCopyToClipboard]="true" />
                    </span>
                  </td>
                  <td>
                    <span class="text-nowrap">
                      <app-phone-number [number]="office.fax" [allowCopyToClipboard]="true" />
                      <a target="_blank" href="/capture-admin/offices/{{ office.id }}">
                        <fa-icon [icon]="['fas', 'external-link-alt']" size="sm" />
                      </a>
                    </span>
                  </td>
                  <td>
                    {{ keyedStatusOptions[office.status]?.display }}
                  </td>
                  <td>
                    @if (office.address1) {
                      <div>{{ office.address1 }}</div>
                    }
                    @if (office.address2) {
                      <div>{{ office.address2 }}</div>
                    }
                    @if (!office.address1 && !office.address2) {
                      <app-blank-value-dash />
                    }
                  </td>
                  <td>
                    {{ office.city | blankValueDash }}
                  </td>
                  <td>
                    {{ office.state | blankValueDash }}
                  </td>
                  <td>
                    {{ office.providerCount }}
                  </td>
                  <td>
                    {{ office.lastUpdatedAt | date: 'MM/dd/yyyy' }}
                  </td>
                </tr>
              }
            </tbody>
          </table>
          <div class="mt-2">
            <app-pagination [paging]="paging" (pageChange)="onPageChange($event)" />
          </div>
        </div>
      } @else {
        <p class="ms-1">No offices.</p>
      }
    </div>
  } @else {
    @if (loading) {
      <div class="ms-1"><mat-spinner diameter="30" /></div>
    }
  }
</div>


